// Module
var code = "<i class=\"icon\" :class=\"name\"></i>\n";
// Exports
export default code;